import { render, staticRenderFns } from "./CircleCard.vue?vue&type=template&id=ef764480&scoped=true&"
import script from "./CircleCard.vue?vue&type=script&lang=js&"
export * from "./CircleCard.vue?vue&type=script&lang=js&"
import style0 from "./CircleCard.vue?vue&type=style&index=0&id=ef764480&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef764480",
  null
  
)

export default component.exports